const dateFormatter = v => {
    if (typeof v == 'undefined') {
        return;
    }

    if (!(v instanceof Date) || isNaN(v)) {
        const match = /(\d{4})-(\d{2})-(\d{2})/.exec(v.slice(0, 10));
        if (match === null) return;
        v = new Date(v);
    }
    const pad = '00';
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();
    return `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
};

const dateParser = v => {
    // v is a string of "YYYY-MM-DD" format
    const match = /(\d{4})-(\d{2})-(\d{2})/.exec(v);
    if (match === null) return;
    const d = new Date(match[1], parseInt(match[2], 10) - 1, match[3], 6);
    if (isNaN(d)) return;
    return d;
};

export default {
    dateFormatter,
    dateParser
};